
import { Routes } from '@angular/router';

import {
  AUTH_ROUTES,
  AuthenticationService,
  AuthenticationGuard,
  AuthorizationService,
  AuthorizationGuard
} from '@c4/auth';
import { DirectorConnectedGuard, DirectorReadyGuard } from '@c4/core';
import { ProgrammingComponent, PROGRAMMING_ROUTES } from '@c4/programming';
import { SYSMAN_ROUTES } from '@c4/sysman';

import { WelcomeComponent } from './welcome/welcome.component';
import { ErrorComponent } from './error/error.component';
import { AboutComponent } from './about/about.component';
import { SplashComponent } from './splash/splash.component';
import { ComposerComponent } from './composer/composer.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { LicenseComponent } from './license/license.component';
import { TOSComponent } from './tos/tos.component';
import { OSSComponent } from './oss/oss.component';
import { BackupProjectComponent } from './backup/backup-project.component';

const composerRoutes: Routes = [
  {
    path: '',
    redirectTo: 'app',
    pathMatch: 'full'
  },
  {
    path: 'app',
    component: ComposerComponent,
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    canActivateChild: [AuthenticationGuard, AuthorizationGuard],
    children: [
      {
        path: '',
        redirectTo: 'about',
        pathMatch: 'full'
      },
      {
        path: 'welcome',
        component: WelcomeComponent,
        canActivate: [DirectorReadyGuard]
      },
      {
        path: 'about',
        component: AboutComponent
      },
      {
        path: 'backup',
        component: BackupProjectComponent,
        canActivate: [DirectorReadyGuard]
      },
      {
        path: 'error',
        component: ErrorComponent,
        canActivate: [DirectorReadyGuard]
      },
      {
        path: 'splash',
        component: SplashComponent,
        canActivate: [DirectorReadyGuard]
      },
      ...PROGRAMMING_ROUTES,
      ...SYSMAN_ROUTES
    ]
  },
  {
    path: 'backup',
    component: BackupProjectComponent,
    canActivate: [DirectorConnectedGuard]
  },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'license', component: LicenseComponent },
  { path: 'tos', component: TOSComponent },
  { path: 'oss', component: OSSComponent }
];

export const appRoutes: Routes = [
  ...composerRoutes,
  ...AUTH_ROUTES
];

console.log('composer routes defn: ', appRoutes);



// WEBPACK FOOTER //
// ./src/app/app.routes.ts